import React from "react"

import { AlternativeLoginForKeycode } from "./AlternativeLogin"
import { LoginWithKeycodeForm } from "./Form"
import { LanguageSelector, NewsBlock, Separator } from "../../components"

export const LoginWithKeycodeScreenContent = () => <>
  <LoginWithKeycodeForm/>
  <Separator/>
  <AlternativeLoginForKeycode/>
  <NewsBlock/>
  <LanguageSelector/>
</>
